import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useGetProjectandEmployeeCoutQuery } from '@/redux/service/employee'

const EMPLOYEE_TABS = [
  { to: '/employees', label: 'Active Employees', end: true as const },
  { to: '/employees/teams', label: 'Teams' },
  { to: '/employees/skills', label: 'Skills' },
  { to: '/employees/pending', label: 'Pending Setup' },
]

export function EmployeeWorkspaceTabs() {
  const { data: count } = useGetProjectandEmployeeCoutQuery()
  const pendingCount = count?.data?.pendingEmployeesCount ?? 0

  return (
    <div className='flex p-1 bg-muted border border-border rounded-xl gap-1 shrink-0 w-fit h-9 items-stretch'>
      {EMPLOYEE_TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          {...(tab.end ? { end: true } : {})}
          className={({ isActive }) =>
            cn(
              'px-4 text-xs font-medium transition-all duration-200 rounded-lg flex items-center justify-center whitespace-nowrap gap-1.5',
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
            )
          }
        >
          {({ isActive }) => (
            <>
              {tab.label}
              {tab.to === '/employees/pending' && pendingCount > 0 && (
                <span
                  className={cn(
                    'min-w-[18px] px-1.5 py-0.5 rounded-full text-[10px] font-bold leading-[2] flex items-center justify-center',
                    isActive
                      ? 'bg-primary-foreground/20 text-primary-foreground'
                      : 'bg-destructive text-destructive-foreground'
                  )}
                >
                  {pendingCount}
                </span>
              )}
            </>
          )}
        </NavLink>
      ))}
    </div>
  )
}
